export default __webpack_public_path__ + "static/media/r4.2e0c17c1.jpg";